import ApiPortMap from "./ApiUrl";
import { getFEWalletParams } from "./../../../platform.pay.config";
import { PParamsData } from "./../../../platform.es.config";

import translate from "./../translate/TranslateJs";


// 获取支付方式列表
export function getPayList(call, callback) {
    getFEWalletParams().toastTip.loading(translate("加载中")())
    getFEWalletParams().ApiGet(ApiPortMap.depositPaymentList)
        .then((res) => {
            getFEWalletParams().toastTip.hide()
            if (res && res.result && Array.isArray(res.result.paymentMethods) && res.result.paymentMethods.length) {
                call(res.result.paymentMethods);
            }
            callback();
        });
}

// 获取支付方式的详情
export function getPayDetail(type, methodCode, call) {
    getFEWalletParams().ApiGet(ApiPortMap.depositDetail + "method=" + type + "&methodCode=" + methodCode + "&isMobile=" + PParamsData().isMobile + "&hostName=" + getFEWalletParams().domainName + "&").then((res) => {
        call(res && res.result);
    }).catch(error => {
        console.log("getPayDetail error:", error);
        return null;
    });
}

// 获取提款方式列表
export function getWithdrawalList(call, callback) {
    getFEWalletParams().toastTip.loading(translate("加载中")())
    getFEWalletParams().ApiGet(ApiPortMap.withdrawalPaymentList)
        .then((res) => {
            getFEWalletParams().toastTip.hide()
            if (res && res.result && Array.isArray(res.result.paymentMethods) && res.result.paymentMethods.length) {
                call(res.result.paymentMethods.filter(v => ['LB', 'CCW'].includes(v.code) ));
            }
            callback();
        });
}

// 获取提款方式的详情
export function getWithdrawalDetail(type, methodCode, call) {
    getFEWalletParams().toastTip.loading(translate("加载中")())
    getFEWalletParams().ApiGet(ApiPortMap.withdrawalDetail + "method=" + type + "&methodCode=" + methodCode + "&isMobile=" + PParamsData().isMobile + "&hostName=" + getFEWalletParams().domainName + "&").then((res) => {
        getFEWalletParams().toastTip.hide()
        call(res && res.result);
    }).catch(error => {
        getFEWalletParams().toastTip.hide()
        console.log("getPayDetail error:", error);
        return null;
    });
}

// 获取会员详细信息
export function getMemberDetail() {
    return getFEWalletParams().ApiGet(ApiPortMap.member).then((res) => {
        let memberInfo = res?.result?.memberInfo;
        formatMemberContacts(memberInfo);
        return memberInfo;
    });
}


// 格式化个人信息的联系方式
export function formatMemberContacts(memberInfo) {
    memberInfo.contacts.forEach((val) => {
        memberInfo["isVerified" + val.contactType] = [val.contact, (val.status === "Verified")];
    });
}

// 获取KYC验证状态
export function getKYCStatus() {
    return getFEWalletParams().ApiGet(ApiPortMap.getMemberKycAndLockStatus);
}

// 获取建议充值金额
export function getAmount(params) {
    return getFEWalletParams().ApiGet(ApiPortMap.getAmount + params);
}

export function getWallets() {
    return getFEWalletParams().ApiGet(ApiPortMap.wallets);
}

// 获取可申请优惠列表
export function getWalletBonus(AccountType, transactionType, call) {
    getFEWalletParams().ApiGet(ApiPortMap.bonusList + transactionType + "&wallet=" + AccountType + "&").then((res) => {
        res && call(res);
    }).catch(error => {
        console.log("GetWalletBonus error:", error);
        return null;
    });
}

// 获取用户已绑定银行卡
export function getMemberBanks(type) {
    return getFEWalletParams().ApiGet(ApiPortMap.memberBanks + "accountType=" + type + "&").then((res) => {
        if (res && Array.isArray(res.result)) {
            let bankList = []
            let result = res.result || []
            let defaultBankIndex = result.findIndex(v => v.isDefault)
            if (defaultBankIndex >= 0) {
                let tempObj = result[defaultBankIndex]
                result[defaultBankIndex] = ''
                result.unshift(tempObj)
                bankList = result.filter(Boolean)
            } else {
                bankList = result
            }
            return bankList
        }
    });
}

// 获取银行卡列表
export function getBankList(call) {
    return getFEWalletParams().ApiGet(ApiPortMap.getWithdrawalbank)
        .then(res => {
            if (res && res.result) {
                call([...res.result.banks, {
                    id: -1,
                    englishName: "OtherBankAccount",
                    name: translate("其它银行")()
                }])
            }
        })
        .catch(error => {
            call([]);
            console.log(error);
        });
}

// 提交充值 || 提交提款
export function CommonPostPay(data, call) {
    getFEWalletParams().toastTip.loading(translate("加载中")())
    getFEWalletParams().ApiPost(ApiPortMap.walletApplication, data).then((res) => {
        getFEWalletParams().toastTip.hide()
        call(res);

        if (getFEWalletParams()?.device == 'APP') {
            getFEWalletParams()?.appPiwikEvent({
                category: 'Withdrawal',
                action: `Submit Withdrawal ${data.paymentMethod}`,
                name: `Withdrawal_${data.paymentMethod}_S_Withdrawal`,
                path: `withdrawal`,
                title: `Withdrawal`,
                isSuccess: res.isSuccess ? 2 : 1,
                customProperties: {
                    [`Withdrawal_${data.paymentMethod}_S_Withdraw_Amount`]: data.amount,
                    [`Withdrawal_${data.paymentMethod}_S_Withdraw_ErrorMsg`]: res?.errors?.[0]?.message || res?.result?.warnings?.[0]?.message
                }
            })
        } else {
            if(getFEWalletParams().webPiwikEvent){
                getFEWalletParams().webPiwikEvent(
                    `Withdrawal`,
                    `Submit Withdrawal(${data.paymentMethod})`,
                    `Withdrawal_${data.paymentMethod}_S_Withdraw`,
                    res.isSuccess ? "2" : "1",
                    [
                        {
                            customVariableKey: res.isSuccess ? false :`Withdrawal_${data.paymentMethod}_S_Withdraw_Amount`,
                            customVariableValue: res.isSuccess ? false : data.amount
                        },
                        {
                            customVariableKey: res.isSuccess ? false :`Withdrawal_${data.paymentMethod}_S_Withdraw_ErrorMsg`,
                            customVariableValue: res.isSuccess ? false : `ErrorMsg: ${res?.errors[0]?.message}` || ""
                        }
                    ]
                )
            }
        }
    }).catch(res => {
        getFEWalletParams().toastTip.hide()
        call(res);
    });
}


// KYC SNC0001 银行卡持卡人姓名填写
export function InsertNewAccountHolderName(bankHolderName, call = () => {}) {
    // getFEWalletParams().toastTip.loading(translate("加载中")())
    getFEWalletParams().ApiPost(ApiPortMap.InsertNewAccountHolderName + 'bankHolderName=' + bankHolderName + '&').then((res) => {
        // getFEWalletParams().toastTip.hide()
        call(res);
    }).catch(res => {
        // getFEWalletParams().toastTip.hide()
        call(res);
    });
}


// 提交充值确认
export function CommonPostConfirmPay(data, call) {
    getFEWalletParams().ApiPost(ApiPortMap.paymentConfirmStep + "transactionId=" + data.transactionId + "&", data).then((res) => {
        call(res);
        // if (res.isSuccess) {
        //     Toast.success("订单成立！交易正在进行中，您的存款将在指定时间内到账，感谢您的耐心等待！", 5);
        // } else {
        //     Toast.error("输入的旧账号错误！");
        // }
    }).catch(error => {
        call(error);
        console.log("CommonPostConfirmPay error:", error);
        return null;
    });
}


export function getCTCListAndExchange(type, call, callback) {
    const FEWalletParams = getFEWalletParams();
    getFEWalletParams().toastTip.loading(translate("加载中")())
    Promise.all([
        FEWalletParams.ApiGet(ApiPortMap.walletAddress + "?cryptoCurrencyCode=" + type + "&"),
        FEWalletParams.ApiGet(ApiPortMap.exchangeRate + "?baseAmount=1&currencyFrom=" + PParamsData().currencyCode + "&currencyTo=" + type + "&")
        // FEWalletParams.ApiGet(ApiPortMap.cryptoCurrencyDetails + "?exchangeAmount=1&methodCode=CHANNEL&coinsCurrency=" + type + "&")
    ]).then((res) => {
        if (res) {
            const ETRC20Data = res?.[0]?.result,
            ExchangeRate = res?.[1]?.result;

            call(ETRC20Data, ExchangeRate);
        }

        getFEWalletParams().toastTip.hide()
    }).finally(() => {
        getFEWalletParams().toastTip.hide()
        callback();
    });
}

export function getExchange(param, call) {
    if (typeof param.money !== "string" || param.money === "") {
        return;
    }
    const FEWalletParams = getFEWalletParams();
    FEWalletParams.ApiGet(ApiPortMap.exchangeRate + "?baseAmount=" + param.money + "&currencyFrom=" + PParamsData().currencyCode + "&currencyTo=" + param.type + "&")
        .then((res) => {
            call(res.result);
        });
}

export function setDefaultBank(id) {
    const FEWalletParams = getFEWalletParams();
    FEWalletParams.ApiPatch(ApiPortMap.SetDefault + `bankId=${id}&`).then(res => {

    })
}



